import S2 from '../assets/images/S2.png'
import S3 from '../assets/images/S3.png'
import S4 from '../assets/images/S4.png'
export const FIGURES = [
  {
    id: '1',
    src: S4,
    title: 'Twórz i modyfikuj',
    description:
      'Stwórz nowe, kompletne e-sprawozdanie finansowe zgodnie z wymogami Ministerstwa Finansów. Przygotowany plik możesz modyfikować dowolną ilość razy przed ostatecznym zapisem.',
  },
  {
    id: '2',
    src: S2,
    title: 'Zweryfikuj poprawność',
    description:
      'Program automatycznie zweryfikuje czy przygotowany przez Ciebie plik jest zgodny ze strukturą opublikowaną przez Ministra Finansów.',
  },
  {
    id: '3',
    src: S3,
    title: 'Zapisz i wyślij',
    description:
      'Pobierz plik na dysk swojego komputera, złóż elektroniczne podpisy i wyślij do Krajowego Rejestru Sądowego lub Krajowej Administracji Skarbowej.',
  },
]
